"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CustomResultView;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function CustomResultView({
  result,
  onClickLink
}) {
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "sui-result"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sui-result__header"
  }, /*#__PURE__*/_react.default.createElement("h3", null, /*#__PURE__*/_react.default.createElement("a", {
    onClick: onClickLink,
    href: result?.url?.raw
  }, result?.name?.raw))), /*#__PURE__*/_react.default.createElement("div", {
    className: "sui-result__body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sui-result__details"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Design Language:"), " ", result?.design_language?.raw), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Backwards Compat:"), " ", result?.backwards_compat?.raw), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Component Library:"), " ", result?.component_library?.raw), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "Availability:"), " ", result?.availability?.raw), result?.see_also?.raw.length > 0 && /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, "See Also:"), " ", /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, result?.see_also?.raw.join(', '))))));
}
CustomResultView.propTypes = {
  result: _propTypes.default.object,
  onClickLink: _propTypes.default.func
};